import React, { memo } from 'react';
import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { makeStyles } from '@mui/styles';

import SimpleModal from '../../SimpleModal';
import Button from '../../Button';
import {
  WARNING,
  CONFIRM,
  CANCEL,
  RECONSOLIDATION_NOTICE_WARNING,
  OK,
} from '../../../constants/strings';
import { Text } from '../../Base';
import warningTextModal from '../../styles/warningTextModal';
import palette from '../../styles/palette';
import { formatStopAddress } from '../../../models/stop';

const useStyles = makeStyles(() => ({
  ...warningTextModal,
  modalRoot: {
    '& .MuiDialog-paperWidthSm': {
      maxWidth: '80% !important',
    },
  },
}));

const ReconsolidationNoticeModal = ({
  open,
  onClose,
  onConfirm,
  info,
  autoConfirm,
}) => {
  const classes = useStyles();

  return (
    <SimpleModal
      onClose={onClose}
      open={open}
      title={WARNING.toUpperCase()}
      rootClassName={classes.modalRoot}
      actions={
        <>
          <Button
            minWidthZero
            onClick={onConfirm}
            className={classes.yellowButton}
          >
            {(!autoConfirm && CONFIRM) || OK}
          </Button>
          {!autoConfirm && (
            <Button
              minWidthZero
              onClick={onClose}
              className={classes.blueButton}
            >
              {CANCEL}
            </Button>
          )}
        </>
      }
    >
      <Grid container direction="column">
        {info && Object.keys(info).length > 0 && (
          <Grid container direction="column">
            <Text
              variant="h6"
              style={{ marginBottom: 8, fontWeight: 'bold', fontSize: '14px' }}
            >
              {RECONSOLIDATION_NOTICE_WARNING}
            </Text>
            {Object.entries(info).map(([deliveryId, stops]) => (
              <Grid
                key={deliveryId}
                container
                direction="column"
                style={{
                  marginBottom: 12,
                  padding: 8,
                  backgroundColor: '#f5f5f5',
                  borderRadius: 4,
                }}
              >
                <Text
                  style={{
                    fontWeight: 'bold',
                    marginBottom: 4,
                    fontSize: '14px',
                  }}
                >
                  Delivery ID: {deliveryId}
                </Text>
                <TableContainer>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell
                          sx={{
                            position: 'sticky',
                            left: 0,
                            background: palette.typography.white.solid,
                            zIndex: 2,
                            minWidth: 45,
                            fontSize: '12px',
                            color: palette.dpdBlack,
                            letterSpacing: '0.11256px',
                            lineHeight: '18px',
                          }}
                          align="left"
                        >
                          Stop
                        </TableCell>
                        <TableCell
                          sx={{
                            background: palette.typography.white.solid,
                            fontSize: '12px',
                            color: palette.dpdBlack,
                            letterSpacing: '0.11256px',
                            lineHeight: '18px',
                            minWidth: 300,
                          }}
                        >
                          Address
                        </TableCell>
                        <TableCell
                          sx={{
                            background: palette.typography.white.solid,
                            fontSize: '12px',
                            color: palette.dpdBlack,
                            letterSpacing: '0.11256px',
                            lineHeight: '18px',
                            minWidth: 71,
                          }}
                        >
                          Postcode
                        </TableCell>
                        <TableCell
                          sx={{
                            background: palette.typography.white.solid,
                            fontSize: '12px',
                            color: palette.dpdBlack,
                            letterSpacing: '0.11256px',
                            lineHeight: '18px',
                            minWidth: 61,
                          }}
                        >
                          Parcels
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {stops.map((stop, index) => (
                        <TableRow key={stop.stopId || index}>
                          <TableCell
                            component="th"
                            scope="row"
                            sx={{
                              position: 'sticky',
                              left: 0,
                              background: palette.typography.white.solid,
                              zIndex: 1,
                              fontSize: '12px',
                              color: palette.dpdBlack,
                              letterSpacing: '0.11256px',
                              lineHeight: '18px',
                            }}
                          >
                            {stop.stopNumber || stop.sequenceNumber}
                          </TableCell>
                          <TableCell
                            sx={{
                              fontSize: '12px',
                              color: palette.dpdBlack,
                              letterSpacing: '0.11256px',
                              lineHeight: '18px',
                              background: palette.typography.white.solid,
                            }}
                          >
                            {formatStopAddress(stop)}
                          </TableCell>
                          <TableCell
                            sx={{
                              fontSize: '12px',
                              color: palette.dpdBlack,
                              letterSpacing: '0.11256px',
                              lineHeight: '18px',
                              background: palette.typography.white.solid,
                            }}
                          >
                            {stop.stopAddress?.postcode}
                          </TableCell>
                          <TableCell
                            sx={{
                              fontSize: '12px',
                              color: palette.dpdBlack,
                              letterSpacing: '0.11256px',
                              lineHeight: '18px',
                              background: palette.typography.white.solid,
                            }}
                          >
                            {stop.parcel.length}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            ))}
          </Grid>
        )}
      </Grid>
    </SimpleModal>
  );
};

export default memo(ReconsolidationNoticeModal);
